const warmed = new Map<string, HTMLImageElement>();

const MAX_WARMED = 4;

/**
 * Starts a fetch now so a later render paints from cache. Fire and forget:
 * a failed warm just means that render pays for the fetch instead.
 */
export function preloadImage(url: string | undefined): void {
  if (!url || typeof window === 'undefined' || warmed.has(url)) return;

  if (warmed.size >= MAX_WARMED) {
    const oldest = warmed.keys().next().value;
    if (oldest !== undefined) warmed.delete(oldest);
  }

  const image = new Image();
  warmed.set(url, image);
  image.onerror = () => warmed.delete(url);
  image.fetchPriority = 'high';
  image.src = url;
}
